import * as React from "react";

export function ArrowTop(props) {
  return (
    <svg
      width={24}
      height={22}
      viewBox="0 0 24 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.096 1.69L.445 17.083c-1.766 3.141 2.107 6.41 4.96 4.187l4.54-3.538a3.35 3.35 0 014.11 0l4.54 3.538c2.853 2.224 6.726-1.046 4.96-4.187L14.905 1.69c-1.268-2.255-4.542-2.255-5.81 0z"
        fill="currentColor"
      />
    </svg>
  );
}
